module.exports = __webpack_public_path__ + "static/media/analysis.7b938948.svg";